import { render, staticRenderFns } from "./BlogDetailsCenterBackground.vue?vue&type=template&id=936fe580&scoped=true&"
import script from "./BlogDetailsCenterBackground.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsCenterBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetailsCenterBackground.vue?vue&type=style&index=0&id=936fe580&scoped=true&lang=css&"
import style1 from "./BlogDetailsCenterBackground.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936fe580",
  null
  
)

export default component.exports